export default __webpack_public_path__ + "static/media/travallo_2.c8be727b.png";